export default __webpack_public_path__ + "static/media/icon-consultar-apolice.632591e3.svg";